import React from 'react';

export default function Step8(props){
    return <div className="seehi_step">
        <h2>Wat kunt u behalve isoleren nog meer doen?</h2>
        <p>Er zijn tal van andere manieren om energie te besparen. Ook hiervoor zijn er vaak subsidieregelingen 
            beschikbaar. Tot 2021 kunt u bijvoorbeeld <a href="https://www.rvo.nl/subsidies-regelingen/investeringssubsidie-duurzame-energie-isde" target="_blank">ISDE subsidie</a> krijgen 
            als u een warmtepomp, zonneboiler, pelletkachel of biomassaketel koopt. Hieronder staan regelingen en informatiebronnen waar u gebruik van kunt maken.</p>

        {/* <h3>Meer informatie</h3> */}
        <ul className="seehi_linklist">
            <li><a href="https://www.verbeteruwhuis.nl" target="_blank">Verbeteruwhuis</a><br />
                <em>Hoe maak ik mijn huis energie­zuiniger en aardgasvrij? Beantwoord de vragen over uw huis, 
                    kies uw verbeteringen en ontdek wat het u kost en oplevert.</em>
            </li>
            <li><a href="https://www.energiebesparendoejenu.nl" target="_blank">Energie besparen doe je nu</a><br />
                <em>Deze website zet alle mogelijkheden op een rij. U kunt op de site zien welke opties er voor uw huis zijn, 
                    welke subsidies er zijn en hoe u snel in contact kunt komen met adviseurs en bedrijven.</em>
            </li>
            <li><a href="https://www.energiesubsidiewijzer.nl/" target="_blank">Energiesubsidiewijzer</a><br />
                <em>Ontdek in twee stappen of er subsidies en aantrekkelijke leningen zijn om uw woning energiezuiniger te maken.</em>
            </li>
            <li><a href="https://www.rvo.nl/subsidies-regelingen/investeringssubsidie-duurzame-energie-isde" target="_blank">ISDE subsidie</a><br/>
                <em>Tot 2021 kunt u subsidie krijgen als u een warmtepomp, zonneboiler, pelletkachel of biomassaketel koopt.</em>
            </li>
            <li><a href="https://www.rvo.nl/subsidies-regelingen/seeh/eigenaar-%C3%A9n-bewoner" target="_blank">Meer over SEEH</a><br/>
	            <em>Lees meer over de regeling SEEH op de website van RVO.nl.</em>
            </li>
        </ul>

    </div>;
}


// WEBPACK FOOTER //
// ./src/steps/step8.js